import MapsService from "@churchofjesuschrist/maps-service";

/**
 * Configure MapsService only once per page using a singleton pattern
 * This prevents multiple configuration calls when multiple components use MapsService
 * @returns {boolean} - true if configuration was successful, false otherwise
 */
export const configureMapsService = () => {
  try {
    // Check if MapsService is available
    if (typeof MapsService === "undefined" || !MapsService.configure) {
      return false;
    }

    // Check if already configured using a global flag
    if (window.__mapsServiceConfigured) {
      return true;
    }

    // Get language from meta tag or fallback to default
    const lang =
      document
        ?.querySelector('meta[name="twoCharacterLang"]')
        ?.getAttribute("content") ||
      document.documentElement.lang ||
      window.PUBLIC_ENV?.lang ||
      "en";

    // Determine if running in production
    const isProd =
      window.PUBLIC_ENV?.LANE === "prod" ||
      !window.location.origin.match(/:\/\/(local|hannah|cuc-|dev|test|stage)/);

    // Configure MapsService
    MapsService.configure({
      client: "MormonOrg",
      language: lang,
      production: isProd
    });

    // Set global flag to prevent reconfiguration
    window.__mapsServiceConfigured = true;

    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Reset the configuration flag (useful for testing)
 */
export const resetMapsServiceConfig = () => {
  window.__mapsServiceConfigured = false;
};
